import ContactToken from '@apps/crm/admin/tokens/contact'
import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import React from 'react'

class Customer extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  _handleBack = this._handleBack.bind(this)
  _handleChoose = this._handleChoose.bind(this)

  render() {
    return <Search { ...this._getSearch() } />
  }

  _getSearch() {
    return {
      endpoint: '/api/admin/finance/invoices',
      filter: {
        status: { $nin: ['paid','voided'] }
      },
      prompt: 't(Choose a customer)',
      compareKey: 'customer.id',
      valueKey: null,
      textKey: 'customer.display_name',
      format: (invoice) =>  <ContactToken { ...invoice.customer } />,
      onChoose: this._handleChoose
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChoose(invoice) {
    const contact = invoice.customer
    this.props.onNext({ contact })
  }

}

export default Customer
